const { protocol, host } = window.location;
const code3ExIncludeScript = `<script src="${protocol}//${host}/plugins/theverse-emoji-plugin.js"></script>\n`;
export default code3ExIncludeScript;
